import {
  Dropdown,
  Option,
  makeStyles,
  tokens,
  Label,
} from '@fluentui/react-components';
import { GlobeRegular } from '@fluentui/react-icons';
import { useTimezone, TIMEZONE_OPTIONS } from './TimezoneProvider';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
  },
  dropdown: {
    minWidth: '200px',
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
  },
});

export function TimezoneSelector() {
  const styles = useStyles();
  const { timezone, setTimezone } = useTimezone();

  const selectedOption = TIMEZONE_OPTIONS.find(opt => opt.value === timezone);
  const dropdownOptions = selectedOption
    ? TIMEZONE_OPTIONS
    : [
        { value: timezone, label: `Detected: ${timezone}` },
        ...TIMEZONE_OPTIONS,
      ];

  return (
    <div className={styles.container}>
      <Label size="small" className={styles.label}>
        <GlobeRegular />
        Timezone
      </Label>
      <Dropdown
        className={styles.dropdown}
        value={selectedOption?.label || `Detected: ${timezone}`}
        onOptionSelect={(_, data) => {
          if (data.optionValue) {
            setTimezone(data.optionValue);
          }
        }}
      >
        {dropdownOptions.map((option) => (
          <Option key={option.value} value={option.value}>
            {option.label}
          </Option>
        ))}
      </Dropdown>
    </div>
  );
}
